
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Sidebar_svg__Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 20.22 25.89","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"Sidebar_svg__st0",attrs:{"d":"M9.99 0h1.29v25.89H9.99zM0 0h8.13v1H0zM0 3.06h8.13v1H0zM0 6.12h8.13v1H0zM14.09 13.93l4.72 4.73-4.73 4.78.71.7 5.43-5.49-5.43-5.43zM6.49 13.22l-5.43 5.43 5.43 5.49.71-.7-4.73-4.79 4.73-4.72z"}})])
          )
        }
      }
    